import { BonusDetail } from "./BonusDetail";
import { RuleModuleType, BonusDetailType } from "../constants/constants";
import { RuleItem } from "./RuleItem";

export type CurrentBonuses = { [key: string]: BonusSourceDetails };

export interface BonusSourceDetails {
  rank: number;
  // TODO: keep track of manual adjustments to rank
  rankAdjustment?: number;
  type: RuleModuleType;
  actualBonus: BonusDetail;
  bonusesFromSources: BonusDetail[];
  targetedBonuses: BonusDetail[];
  progressionBonuses: BonusDetail[];
  rankIncreases: BonusDetail[];
}

export const emptyBonusSourceDetails: BonusSourceDetails = {
  rank: 0,
  type: RuleModuleType.ItemOnly,
  bonusesFromSources: [],
  targetedBonuses: [],
  progressionBonuses: [],
  rankIncreases: [],
  actualBonus: {
    sourceName: "",
    sourceKey: "",
    current: 0,
    bonusDetailType: "bonus-unknown",
  },
};

export function buildBonusSourceDetails(
  ruleItem: RuleItem,
  rank: number,
  current: number,
  sources: BonusDetail[],
  targeted: BonusDetail[],
  progressions: BonusDetail[],
  rankIncreases: BonusDetail[],
  moduleType: RuleModuleType,
  bonusDetailType: BonusDetailType
): BonusSourceDetails {
  return {
    rank: rank,
    type: moduleType,
    actualBonus: {
      sourceName: ruleItem.name,
      sourceKey: ruleItem.key,
      current,
      bonusDetailType,
    },
    bonusesFromSources: sources,
    targetedBonuses: targeted,
    progressionBonuses: progressions,
    rankIncreases,
  };
}
